import React from "react";
import { Col, Space } from "antd";
import RentReviewList from "../../components/RentReviewList";

function RentReviewManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">이용 후기 관리</h3>
                <RentReviewList />
            </Space>
        </div>
    );
}

export default RentReviewManagement;
